export const dynamicColumnWidth = 100;
export const maxDynamicColumns = 126; // 18 weeks × 7 days
